/** @format */

import React, { useMemo, useState } from 'react'
import { Button, dayjs, DescriptionItem, Descriptions, Drawer, Tab, Tabs } from '@king-design/react'
import styled from 'styled-components'
import { ConcatProps } from 'src/components/AlarmReciver/new'
import ReactJson from 'react-json-view'
import { Cell } from '@antv/x6'

import Readonly from '../../Scene/Detail/SceneGraph/NodeDrawer/Readonly'
import { useAsync } from 'react-use'
import { getScene } from 'src/api/ApiEventOpsScene'
import { getFlowParamsInfo } from '../../Scene/container'

export interface NodeDetailProps {
  id: number
  name: string
  type: string
  detail: {
    inputs: {
      value: string
      key: string
    }[]
    createdAt: string
    finishedAt: string
    outputs: {
      value: string
      key: string
    }[]
    scriptID: number
  }
  config: {
    inputs: {
      sourceNode: string
      sourceNodeSign: string
      sourceKey: string
      type: string
      value: string
      secret: boolean
      key: string
    }[]
    outputs: {
      type: string
      key: string
    }[]
    urlNotices: string[]
    userNotices: ConcatProps[]
  }
}
interface NodeDrawerProps {
  className?: string
  visible: boolean
  onClose: () => void
  node: Cell.Properties
  nodeVariable?: {
    inputs: {
      [key: string]: string
    }
    outputs: {
      [key: string]: string
    }
  }
}

const NodeDrawer: React.FC<NodeDrawerProps> = ({
  className,
  visible,
  onClose,
  node,
  nodeVariable
}) => {
  const [tab, setTab] = useState('detail')
  const nodeData = useMemo(() => {
    if (visible && node) {
      return node.data
    } else {
      return {}
    }
  }, [visible, node])

  const { procesDetails, subSceneSign } = nodeData

  // 请求子场景信息
  const { value: subSceneInfo } = useAsync(async () => {
    if (visible && node.data?.subSceneSign) {
      const subSceneResult = await getScene(subSceneSign)
      const subSceneInputs = getFlowParamsInfo(subSceneResult, 'input')
      const subSceneOutputs = getFlowParamsInfo(subSceneResult, 'output')
      return {
        name: subSceneResult.Name,
        inputs: subSceneInputs,
        outputs: subSceneOutputs
      }
    } else {
      return {
        name: '',
        inputs: [],
        outputs: []
      }
    }
  }, [visible, subSceneSign])

  return (
    <Drawer
      value={visible}
      width={900}
      title={node?.name}
      mode="destroy"
      container={() => document.querySelector('#record_detail')}
      onChangeValue={show => {
        if (!show) {
          setTab('detail')
          onClose()
        }
      }}
      slotFooter={
        <Button
          onClick={() => {
            setTab('detail')
            onClose()
          }}
        >
          关闭
        </Button>
      }
    >
      <div className={className}>
        <Tabs
          value={tab}
          onChangeValue={tab => {
            setTab(tab)
          }}
        >
          <Tab value="detail">节点详情</Tab>
          <Tab value="config">节点配置</Tab>
        </Tabs>
        {node ? (
          <div className="tab_content">
            {tab === 'detail' ? (
              <>
                <Descriptions columns={1} className={className}>
                  <DescriptionItem label="节点名称">{node?.data?.name || '-'}</DescriptionItem>
                  <DescriptionItem label="开始时间">
                    {procesDetails?.CreatedAt
                      ? dayjs(procesDetails?.CreatedAt).format('YYYY-MM-DD HH:mm:ss')
                      : '-'}
                  </DescriptionItem>
                  <DescriptionItem label="结束时间">
                    {procesDetails?.FinishedAt
                      ? dayjs(procesDetails?.FinishedAt).format('YYYY-MM-DD HH:mm:ss')
                      : '-'}
                  </DescriptionItem>
                  <DescriptionItem label="输入参数">
                    <ReactJson
                      src={nodeVariable?.inputs}
                      name={false}
                      displayDataTypes={false}
                      displayObjectSize={false}
                      quotesOnKeys={false}
                      enableClipboard={false}
                      collapsed={1}
                    />
                  </DescriptionItem>
                  <DescriptionItem label="输出参数">
                    <ReactJson
                      src={nodeVariable?.outputs}
                      name={false}
                      displayDataTypes={false}
                      displayObjectSize={false}
                      quotesOnKeys={false}
                      enableClipboard={false}
                      collapsed={1}
                    />
                  </DescriptionItem>
                </Descriptions>
              </>
            ) : (
              <Readonly record={node?.data} subSceneInfo={subSceneInfo} />
            )}
          </div>
        ) : null}
      </div>
    </Drawer>
  )
}

export default styled(NodeDrawer)`
  .tab_content {
    padding: 16px;
  }
  .k-description-item {
    width: 702px;
    align-items: flex-start;
    .k-description-centent {
      .c-ellipsis {
        white-space: normal;
      }
      max-width: 700px;
    }
  }
`
